function Svk_na_fchapt_stuba(){
    return(
        <div>
            <h1 style={{ textAlign: "center", color: "black" }}>
                26. celoslovenská študentská vedecká konferencia
            </h1>
            <h2 style={{ textAlign: "center", color: "black" }}>
                "Chémia a technológie pre život 2024"
            </h2>
            <hr style={{ color: "#999999", height: "5px"}} />
            
        

        <p>
          S ohľadom na epidemiologickú situáciu sa ŠVK bude konať aj tento rok v
          online formáte.
        </p>



        <p>
          <b>Registrácia</b> príspevkov je už otvorená a študentské príspevky je
          možné zaregistrovať <b>do štvrtku 31.10.2024</b> na stránke ŠVK:
        </p>

        <p
          style={{
            marginBottom: "0cm",
            textAlign: "center",
            lineHeight: "normal",
          }}
        >
          <a
            href="https://ukazsvojuchemiu.sk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ukazsvojuchemiu.sk/
          </a>
        </p>

        <br/>

        <p>
          Študentská vedecká konferencia je príležitosťou pre študentov bakalárskeho a
          inžinierskeho štúdia, aby prezentovali svoje vedecké a odborné práce. Na ŠVK
          prebehne v jednotlivých sekciách aj neformálna prehliadka prác študentov
          doktorandského štúdia. Abstrakty všetkých registrovaných príspevkov budú
          zverejnené v elektronickom recenzovanom zborníku s ISBN číslom.
        </p>

        <br/>

        <p>
          Najlepšie prezentované práce v jednotlivých sekciách budú finančne odmenené.
          Vďaka podpore partnerov ŠVK sa študenti môžu tešiť na zaujímavé finančné odmeny a
          vecné ceny pre víťazov. Čas na ŠVK, ako aj jednotlivé umiestnenie v sekciách, sa
          bodovo zohľadňujú v prijímacom konaní na doktorandské štúdium.
        </p>

        <br/>

        <p>
          Budeme radi, ak nás budete sledovať aj na Facebooku:
        </p>

        <p
          style={{
            marginBottom: "0cm",
            textAlign: "center",
            lineHeight: "normal",
          }}
        >
          <a
            href="https://www.facebook.com/svk.fchpt.stu"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.facebook.com/svk.fchpt.stu
          </a>
        </p>

        <p>
          a od tohto roku aj na Instagrame:
        </p>

        <p
          style={{
            marginBottom: "0cm",
            textAlign: "center",
            lineHeight: "normal",
          }}
        >
          <a
            href="http://www.instagram.com/chemia_a_technologie_pre_zivot"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.instagram.com/chemia_a_technologie_pre_zivot
          </a>          
        </p>

        <br/>
        
        <h5>Dôležité termíny:</h5>

        <ul>
          <li>
            <strong>
                otvorenie registrácie: 
            </strong>
            16. septembra 2024
          </li>
          <li>
            <strong>
                odovzdanie príspevkov a registrácia:
            </strong>
                31. októbra 2024
          </li>
          <li>
            <strong>
                konanie konferencie:
            </strong>
            21. novembra 2024
          </li>
        </ul>

        <br/>

        <p>
          Pre písanie abstraktu si pozrite na stránke konferencie Informácie pre autorov,
          kde si stiahnete aj Template pre písanie abstraktu.
        </p>

        <p           
            style={{
            marginBottom: "0cm",
            textAlign: "center",
            lineHeight: "normal",
          }}>
          <a
            href="https://www.uiam.sk/svk/?q=informacie-pre-autorov"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.uiam.sk/svk/?q=informacie-pre-autorov
          </a>
        </p>

        <p>
          &nbsp;
        </p>

        <p>
          V archíve sa nachádzajú staré zborníky. Pre inšpiráciu si ich môžete pozrieť.
        </p>

        <p>
          22.SVK&nbsp;
          <a
            href="https://www.uiam.sk/~oravec/svk/e_zbornik_svk_2020.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.uiam.sk/~oravec/svk/e_zbornik_svk_2020.pdf
          </a>
        </p>

        <p>
          21SVK{" "}
          <a
            href="https://www.uiam.sk/~oravec/svk/e_zbornik_svk_2019.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.uiam.sk/~oravec/svk/e_zbornik_svk_2019.pdf
          </a>
        </p>

        <br/>

        <p>
          Alebo na stránke{" "}
          <a
            href="https://ukazsvojuchemiu.sk/pre-autorov/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ukazsvojuchemiu.sk/pre-autorov/
          </a>
        </p>
      </div>
    );
};

export default Svk_na_fchapt_stuba;